import { render, staticRenderFns } from "./Fabrics.vue?vue&type=template&id=36d810ca&scoped=true"
import script from "./Fabrics.vue?vue&type=script&lang=js"
export * from "./Fabrics.vue?vue&type=script&lang=js"
import style0 from "./Fabrics.vue?vue&type=style&index=0&id=36d810ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d810ca",
  null
  
)

export default component.exports